module.exports = __webpack_public_path__ + "static/media/coreValues-05.0da50344.svg";